import classNames from 'classnames'
import { CircleCheckIcon } from '@/atoms/Icons/CircleCheckIcon'
import { EmptyCircleIcon } from '@/atoms/Icons/EmptyCircleIcon'
import { CaptionLG } from '@/atoms/Text'
import { formatPrice } from '@/services/PriceFormatter'
import { CollectibleProductPack } from '@/types/codegen-federation'

interface CollectiblesPackItemProps {
  pack: CollectibleProductPack | null
  isSelected: boolean
  handleSelectPack: (pack: CollectibleProductPack) => void
  fullPrice: number
  savings: number
}

export const CollectiblesPackItem: React.FC<CollectiblesPackItemProps> = ({ pack, isSelected, handleSelectPack }) => {
  return (
    <div
      key={pack?.id}
      className={classNames(
        'my-4 grid grid-cols-[32px_1fr_90px] rounded-lg border-2 p-4 grid-rows-[auto_auto] gap-x-2 cursor-pointer',
        isSelected ? 'bg-oxide-primary/10 border-oxide-primary' : 'border-gray-300',
      )}
      onClick={() => {
        handleSelectPack(pack as CollectibleProductPack)
      }}
    >
      <div className="col-start-1 row-span-full place-self-center justify-self-start">
        {isSelected ? (
          <CircleCheckIcon size={24} color1="oxide-primary" color2="white" />
        ) : (
          <EmptyCircleIcon size={24} color1="black" />
        )}
      </div>
      <div className="flex flex-row place-items-center space-x-2">
        <CaptionLG weight="bold" className="w-fit">
          {pack?.name}
        </CaptionLG>
      </div>
      <div className="col-start-3 row-span-full flex flex-wrap justify-end gap-2 place-self-center  justify-self-end text-right">
        <CaptionLG>{formatPrice(pack?.price ?? 0, { currency: 'USD', ignoreEmptyDecimal: true })}</CaptionLG>
      </div>
      <CaptionLG>{pack?.description}</CaptionLG>
    </div>
  )
}
